import React, { useEffect, useRef } from "react";
import {
  BoldExtension,
  ItalicExtension,
  UnderlineExtension,
  FontSizeExtension,
  TextColorExtension,
  HeadingExtension,
  BulletListExtension,
  HardBreakExtension,
  LinkExtension,
  OrderedListExtension,
  ImageExtension,
  SubExtension,
  SupExtension,
  TextHighlightExtension
} from "remirror/extensions";
import { TableExtension } from "@remirror/extension-react-tables";
import {
  EditorComponent,
  Remirror,
  useRemirror,
  ReactComponentExtension,
} from "@remirror/react";
import "remirror/styles/all.css";
import { EditorMenu } from "../EditorMenu";

export const WYSIWYGEditor = ({ initialContent = '', handleChange }) => {
  const { manager, state, setState } = useRemirror({
    extensions: () => [
      new BoldExtension(),
      new ItalicExtension(),
      new UnderlineExtension(),
      new FontSizeExtension(),
      new TextColorExtension(),
      new HeadingExtension(),
      new BulletListExtension(),
      new OrderedListExtension(),
      new LinkExtension(),
      new HardBreakExtension(),
      new ReactComponentExtension(),
      new TableExtension(),
      new ImageExtension({ enableResizing: true }),
      new SubExtension(),
      new SupExtension(),
      new TextHighlightExtension(),
    ],
    selection: "start",
    stringHandler: "html",
    content: initialContent,
  });

  const contentRef = useRef(initialContent);

  useEffect(() => {
    if (initialContent !== contentRef.current) {
      setState(manager.createState({ content: initialContent, selection: "end" }));
      contentRef.current = initialContent; // Prevent unnecessary re-renders
    }
  }, [initialContent, manager, setState]);

  const onChange = (parameter) => {
    setState(parameter.state);
    contentRef.current = parameter.helpers.getHTML();
    handleChange(parameter.helpers.getHTML());   
  };

  return (
    <div className="remirror-theme">
      <Remirror manager={manager} state={state} onChange={onChange}>
        <EditorMenu />
        <EditorComponent />
      </Remirror>
    </div>
  );
};
